import request from "@/utils/request";

const api = {
  report: "/app/access/log/report"
};

/**
 * 访问类型常量
 */
export const ACCESS_TYPE = {
  APP_CLICK: 1,
  MENU_CLICK: 2
};

/**
 * 上报应用/菜单访问日志
 * @param {Object} parameter - { appName, menuName, menuPath, accessType }
 */
export function reportAppAccess(parameter) {
  return request({
    url: api.report,
    method: "post",
    data: parameter
  });
}
